import { Injectable } from "@angular/core";
import { EndpointFactoryService } from "../../../services/endpoint-factory.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ResponseModel } from "../../../models/response.model";
import { KeyValue } from "../../../models/key-value";

@Injectable({
  providedIn: "root",
})
export class ImportCsvService extends EndpointFactoryService {
  importCsv(
    url: string,
    file: File,
    extra: KeyValue[] = [],
  ): Observable<ResponseModel> {
    const formData = new FormData();
    formData.append("file", file, file.name);
    extra.forEach((p) => {
      formData.append(p.key, p.value);
    });
    return this.http
      .post(this.configurations.baseUrl + url, formData, {
        headers: this.getFormDataRequestHeaders().headers,
      })
      .pipe(map((response) => response as ResponseModel));
  }
}
